<script setup lang="ts">
defineOptions({ inheritAttrs: false });
defineProps<{ items: any[] }>();
</script>
<template>
  <nut-collapse class="mp-collapse" v-bind="$attrs">
    <nut-collapse-item
      v-for="(item, index) in items"
      :key="index"
      v-bind="item"
    >
      <template #icon v-if="$slots[`${item.name}_icon`]">
        <slot :name="`${item.name}_icon`" />
      </template>
      <template #title v-if="$slots[`${item.name}_title`]">
        <slot :name="`${item.name}_title`" />
      </template>
      <template #value v-if="$slots[`${item.name}_value`]">
        <slot :name="`${item.name}_value`" />
      </template>
      <template #extra v-if="$slots[`${item.name}_extra`]">
        <slot :name="`${item.name}_extra`" />
      </template>
      <template #default v-if="$slots[`${item.name}_default`]">
        <slot :name="`${item.name}_default`" />
      </template>
    </nut-collapse-item>
  </nut-collapse>
</template>
<style lang="scss">
.mp-collapse {
  .nut-collapse-item__title,
  .nut-collapse__item-wrapper__content {
    padding: 10px !important;
  }
}
</style>
